import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { AssignedStateToggle } from "../../../../components/AssignedStateToggle";
import type { ActionFilter, Filters } from "../types";
import { defaultFilters, isDefaultFilters } from "../types";

const ACTION_FILTER_OPTIONS: ReadonlyArray<{
  value: ActionFilter;
  label: string;
}> = [
  { value: "any", label: "Any action" },
  { value: "source", label: "Sets source" },
  { value: "merchant", label: "Sets merchant" },
  { value: "description", label: "Sets description" },
  { value: "group", label: "Sets group" },
  { value: "amount", label: "Sets amount" },
  { value: "expenseType", label: "Sets expense type" },
  { value: "datePaid", label: "Sets date" },
  { value: "category", label: "Adds/removes category" },
  { value: "attachment", label: "Adds/removes attachment" },
  { value: "receipt", label: "Sets receipt" },
  { value: "applyAutoTx", label: "Applies another rule" },
  { value: "ignore", label: "Ignore" },
  { value: "askUser", label: "Asks user" },
  { value: "copyField", label: "Copies a field" },
];

export type AutoTransactionFiltersProps = {
  value: Filters;
  onChange: (next: Filters) => void;
};

export const AutoTransactionFilters = ({
  value,
  onChange,
}: AutoTransactionFiltersProps) => {
  const update = <K extends keyof Filters>(key: K, next: Filters[K]) =>
    onChange({ ...value, [key]: next });

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <AssignedStateToggle
            label="Enabled"
            icon={<ToggleOnIcon />}
            value={value.enabled}
            onChange={(v) => update("enabled", v)}
          />
        </Box>
        <TextField
          size="small"
          label="Name, description or condition contains"
          value={value.namePattern}
          onChange={(e) => update("namePattern", e.target.value)}
          sx={{ minWidth: 280 }}
        />
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel id="auto-tx-action-filter">Action touches</InputLabel>
          <Select
            labelId="auto-tx-action-filter"
            label="Action touches"
            value={value.actionField}
            onChange={(e) =>
              update("actionField", e.target.value as ActionFilter)
            }
          >
            {ACTION_FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!isDefaultFilters(value) && (
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={() => onChange(defaultFilters)}
          >
            Clear
          </Button>
        )}
      </Box>
    </Paper>
  );
};
